import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import CellStyleWrapper from '../../../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'
// import Link from '../../../../../../../../../../../../../components/TableCell/components/Link'
import Money from '../../../../../../../../../../../../../components/TableCell/components/Money'
import CustomDate from '../../../../../../../../../../../../../components/CustomDate'
import NoData from '../../../../../../../../../../../components/Workspace/components/NoData'
import FailedLoad from '../../../../../../../../../../../components/Workspace/components/FailedLoad'

import { LOCALE_PREFIX } from '../../../../constants'

import Parts from './components/Parts'
import Publishers from './components/Publishers'

import hocConnect from './hocConnect'
import './styles.scss'

@hocConnect
@injectIntl
export default class Table extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        data: PropTypes.array,
        failed: PropTypes.bool,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        loaded: PropTypes.bool,
        loadTableData: PropTypes.func.isRequired,
        locale: PropTypes.string,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        sorted: PropTypes.array,
    }

    componentDidMount() {
        const { loaded, dataLocale, locale } = this.props

        if (!loaded || dataLocale !== locale) this.loadData()
    }

    componentDidUpdate(prevProps) {
        const { level } = this.props

        if (prevProps.level !== level) this.loadData()
    }

    loadData = () => {
        const { module, block, id, level, loadTableData } = this.props

        loadTableData(module, block, id, level)
    }

    handleTableChange = (changeData) => {
        const { module, block, id, level, loadTableData } = this.props

        loadTableData(module, block, id, level, changeData)
    }

    renderSubComponent = (rowData) => {
        const { module, block, id, level, locale } = this.props
        const tenderId = rowData?.row?.original?.id

        return (
            <>
                <Parts module={module} block={block} id={id} level={level} locale={locale} tenderId={tenderId} />
                <Publishers module={module} block={block} id={id} level={level} locale={locale} tenderId={tenderId} />
            </>
        )
    }

    render() {
        const { id, intl, isLoading, data, pagination, sorted, failed } = this.props

        // Failed data load
        if (failed && !isLoading) {
            return (
                <div className={'assigned-tenders-table-no-data-wrapper'}>
                    <FailedLoad
                        customCallback={this.loadData}
                        customText={intl.formatMessage({ id: 'global.failedToLoadTabContent' })}
                        show={failed}
                    />
                </div>
            )
        }

        // Empty data
        if (_.isEmpty(data) && !isLoading && !failed) {
            return (
                <div className={'assigned-tenders-table-no-data-wrapper'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.assignedTenders.noData` })} />
                </div>
            )
        }

        return (
            <div className={'assigned-tenders-table-wrapper'}>
                <FilterTable
                    id={`assigned-tenders-filter-table-${id}`}
                    itemIdentifier={'id'}
                    data={data}
                    loading={isLoading}
                    columnsDefinition={[
                        {
                            accessor: 'number',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.assignedTenders.registrationNumber` }),
                            // Cell: ({ value, original }) => (
                            //     <CellStyleWrapper isCentered>
                            //          <Link
                            //             label={value}
                            //             url={original?.url}
                            //             showIcon
                            //             openOnNewTab
                            //             iconType={'external'}
                            //          />
                            //     </CellStyleWrapper>
                            // ),
                            Cell: ({ value }) => <CellStyleWrapper isCentered>{value}</CellStyleWrapper>,
                            width: 200,
                        },
                        {
                            accessor: 'name',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.assignedTenders.name` }),
                            Cell: ({ value }) => (
                                <CellStyleWrapper isCentered>
                                    <div className={'assigned-tenders-name-cell'} title={value}>
                                        <span>{value || '-'}</span>
                                    </div>
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'supplierCount',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.assignedTenders.numberOfSuppliers` }),
                            Cell: ({ value }) => (
                                <CellStyleWrapper isCentered>
                                    <span>{value || '-'}</span>
                                </CellStyleWrapper>
                            ),
                            width: 130,
                        },
                        {
                            accessor: 'publisherCount',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.assignedTenders.numberOfPublishers` }),
                            Cell: ({ value }) => (
                                <CellStyleWrapper isCentered>
                                    <span>{value || '-'}</span>
                                </CellStyleWrapper>
                            ),
                            width: 130,
                        },
                        {
                            accessor: 'value',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.assignedTenders.value` }),
                            Cell: ({ value }) => (
                                <CellStyleWrapper isCentered>
                                    <Money value={value} emptyValue={'-'} showCurrency={false} />
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'value.currency',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.assignedTenders.currency` }),
                            Cell: ({ value }) => (
                                <CellStyleWrapper isCentered>
                                    <FormattedMessage id={`global.currency.${value}`} />
                                </CellStyleWrapper>
                            ),
                            sortable: true,
                        },
                        {
                            accessor: 'publishDate',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.assignedTenders.published` }),
                            Cell: ({ value }) => (
                                <CellStyleWrapper isCentered>
                                    <CustomDate date={value?.value} precision={value?.precision} />
                                </CellStyleWrapper>
                            ),
                            sortable: true,
                            width: 130,
                        },
                    ]}
                    settings={{
                        pagination,
                        sorted,
                    }}
                    SubComponent={(rowData) => this.renderSubComponent(rowData)}
                    expandOnRowClick
                    onTableChange={this.handleTableChange}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                    }}
                />
            </div>
        )
    }
}
